import { render, staticRenderFns } from "./NewUserManagementModal.vue?vue&type=template&id=38888330&"
import script from "./NewUserManagementModal.vue?vue&type=script&lang=ts&"
export * from "./NewUserManagementModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewUserManagementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports